export default __webpack_public_path__ + "static/recognition-5b246daf8ca2e6b9c13b44eb05f20f7a.jpg";